import { ExternalLink } from 'lucide-react';
import { Dialog, DialogContent, DialogDescription, DialogTitle } from './dialog';

/**
 * Ein Bild groß über der Seite statt in einem neuen Tab (T-0148).
 *
 * Schließen mit Esc oder Klick daneben; „In neuem Tab" bleibt für den Fall, dass
 * man hineinzoomen will.
 */
export default function BildLightbox({
  url,
  titel = 'Bild',
  onSchliessen,
}: Readonly<{ url: string | null; titel?: string; onSchliessen: () => void }>) {
  return (
    <Dialog open={url !== null} onOpenChange={(offen) => (!offen ? onSchliessen() : undefined)}>
      <DialogContent className="max-w-[95vw] w-auto p-2 sm:max-w-[95vw]">
        <DialogTitle className="sr-only">{titel}</DialogTitle>
        <DialogDescription className="sr-only">Großansicht. Esc schließt.</DialogDescription>
        {url ? (
          <div className="space-y-2">
            <img src={url} alt={titel} className="max-h-[85vh] max-w-full rounded object-contain" />
            <a
              href={url}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-1 text-xs text-muted-foreground hover:underline"
            >
              <ExternalLink className="h-3 w-3" /> In neuem Tab öffnen
            </a>
          </div>
        ) : null}
      </DialogContent>
    </Dialog>
  );
}
